module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_6005.ec29f237.png";